import { AccountGroup } from "@common/types/domains/accounting/account";
import {
    AccountWithEntity,
    buildCoaAccountTree,
    CoaAccountTreeNode,
} from "../CoaAccountFilter/coaAccountTree";

const collectLeaves = (
    nodes: readonly CoaAccountTreeNode[],
): CoaAccountTreeNode[] =>
    nodes.flatMap((node) =>
        node.children.length === 0 ? [node] : collectLeaves(node.children),
    );

export function scopeAccountIdsToEntities({
    accountIds,
    accounts,
    entityIds,
}: {
    accountIds: string[] | undefined;
    accounts: AccountWithEntity[] | undefined;
    entityIds: number[] | undefined;
}): string[] | undefined {
    if (!accountIds?.length || !accounts || !entityIds?.length) {
        return accountIds;
    }
    const entityIdSet = new Set(entityIds);
    const inScopeAccountIds = new Set(
        accounts
            .filter((account) => entityIdSet.has(account.entityId))
            .map((account) => account.id),
    );
    const scopedAccountIds = accountIds.filter((id) =>
        inScopeAccountIds.has(id),
    );
    return scopedAccountIds.length > 0 ? scopedAccountIds : undefined;
}

export function countSelectedAccountRows({
    accountIds,
    accounts,
    groups,
    entityIds,
}: {
    accountIds: string[];
    accounts: AccountWithEntity[] | undefined;
    groups: AccountGroup[] | undefined;
    entityIds: number[] | undefined;
}): number {
    const tree = buildCoaAccountTree({
        accounts,
        groups,
        entityIds: entityIds?.length ? entityIds : undefined,
    });
    const selectedIdSet = new Set(accountIds);
    const selectedRowCount = collectLeaves(tree).filter(
        (leaf) =>
            leaf.accountIds.length > 0 &&
            leaf.accountIds.every((id) => selectedIdSet.has(id)),
    ).length;
    return selectedRowCount > 0 ? selectedRowCount : accountIds.length;
}
